import * as React from 'react';
import { useState } from 'react';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { SidebarTab } from './types';
/** @jsx jsx */
import { jsx } from 'theme-ui';

export interface SidebarTabProps {
  initialActiveTab: SidebarTab;
  onChangeTab: (tab: SidebarTab) => void;
  showChangeTabConfirmDialog: boolean;
}

export const SidebarTabs = (props: SidebarTabProps) => {
  const { initialActiveTab, onChangeTab, showChangeTabConfirmDialog } = props;

  const intl: IntlShape = useIntl();
  const [activeTab, setActiveTab] = useState<SidebarTab>(initialActiveTab);

  return (
    <div sx={{
      mb: "1em",
      ".tabs": {
        borderColor: "primary",
        ".tabs-inner": {
          display: "flex",
          justifyContent: "center"
        },
      },
      ".tab": {
        fontSize: ["17.2px", "17.2px", "17.2px", "17.2px", "1.2em", "1.2em"],
        p: "0.2em 0",
        cursor: "pointer",
        backgroundColor: "transparent",
        color: "primary",
        flexGrow: 1,
        border: "none",
        borderBottom: "1px solid",
        borderColor: "primary",
        borderTop: "5px solid transparent",
        mb: -1,
        "&.active": {
          borderTop: "5px solid",
          borderLeft: "1px solid",
          borderRight: "1px solid",
          borderBottom: "1px solid",
          borderColor: "primary",
          borderBottomColor: "transparent"
        },
        "&:hover": {
          borderTop: "5px solid",
          borderColor: "secondary"
        }
      }
    }}>
      <div className="tabs">
        <div className="tabs-inner">
          <button
            className={activeTab === SidebarTab.PUBLIST ? 'tab active' : 'tab'}
            onClick={(e) => {
              e.preventDefault();
              let confirm = true;
              if (showChangeTabConfirmDialog) {
                confirm = window.confirm(intl.formatMessage({id: 'publist.popup.changed_lost_on_route_change'}));
              }
              if (confirm) {
                setActiveTab(SidebarTab.PUBLIST);
                onChangeTab(SidebarTab.PUBLIST);
              }
            }}
          >
            <FormattedMessage id="publig.sidebar.tab.publist" />
          </button>
          <button
            className={activeTab === SidebarTab.RESEARCH_DATA_LIST ? 'tab active' : 'tab'}
            onClick={(e) => {
              e.preventDefault();
              let confirm = true;
              if (showChangeTabConfirmDialog) {
                confirm = window.confirm(intl.formatMessage({id: 'publist.popup.changed_lost_on_route_change'}));
              }
              if (confirm) {
                setActiveTab(SidebarTab.RESEARCH_DATA_LIST);
                onChangeTab(SidebarTab.RESEARCH_DATA_LIST);
              }
            }}
          >
            <FormattedMessage id="publig.sidebar.tab.research_data_list" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SidebarTabs;
